import { render, staticRenderFns } from "./TruckEdit.vue?vue&type=template&id=8a31d5bc&scoped=true"
import script from "./TruckEdit.vue?vue&type=script&lang=js"
export * from "./TruckEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a31d5bc",
  null
  
)

export default component.exports